export default class EmployeeAssessmentResult {
  totalPercent: number;

  responsibilityPercent: number;

  knowledgePercent: number;

  behaviorPercent: number;

  constructor(obj: any = {}) {
    this.totalPercent = obj.totalPercent || 0;
    this.responsibilityPercent = obj.responsibilityPercent || 0;
    this.knowledgePercent = obj.knowledgePercent || 0;
    this.behaviorPercent = obj.behaviorPercent || 0;
  }
}
